import { Box, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Text, VStack } from "@chakra-ui/react";
import React, { Suspense, useState } from "react";
import { AlloprofLogo, FloSplash } from "../APAssetAtlas";
import App from "../../App";
import { useVocabIntl } from "../../hooks/useVocabTranslation";

export function InitializationModal() {
  const [ready, setReady] = useState(false);
  const { APFormattedMessage } = useVocabIntl()
  return (<>
    <Modal
      closeOnOverlayClick={false}
      size={"full"}
      variant={"full"}
      isOpen={!ready}
      motionPreset="slideInBottom"
      onClose={() => {}}>
      <ModalOverlay>
        <ModalContent bgColor={"lightBlue.500"} bgImage={"var(--ap-theme-default)"} bgPos={"bottom"} bgSize={"cover"}
                      bgRepeat={"no-repeat"}>
          <ModalBody maxHeight={"100%"} display={"flex"} borderTopRadius={"1.5rem"} gap={"1rem"} position={"relative"}
                     alignItems={"center"} justifyContent={"center"} zIndex={10} overflow={"clip"} bg={"transparent"}
                     minH={0}>
            <AlloprofLogo preserveAspectRatio={"meet"} title="Alloprof" height={["2em", null, "3em"]} width={"auto"}
                          margin={["0.5em", null, "2em"]} />
            <VStack alignItems={"center"}>
              <Text fontSize={["lg", "xl"]}>Exercice interactif de</Text>
              <Text fontSize={["4xl", "5xl"]} lineHeight="1em" fontWeight={900}>vocabulaire</Text>
            </VStack>
            <VStack gap={"0.5rem"}>
              <Text fontSize="lg" textAlign="center">
                <APFormattedMessage id={"splash-getting-ready"} />
              </Text>
              <Text fontSize="md" textAlign="center">
                <APFormattedMessage id={"splash-getting-ready-wait"} />
              </Text>
              <Spinner size={"lg"} emptyColor={"secondary.fg"} color={"primary.fg"} />
            </VStack>
            <Box height={"10rem"} display={"flex"} flexShrink={1}></Box>
            <FloSplash preserveAspectRatio={"meet"} position={"absolute"} zIndex={-1} maxHeight={"50%"}
                       width={"96%"} height={"auto"} maxWidth={"30rem"} bottom={0} transform={"translate(0,35%)"} />
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
    <Suspense fallback={null}>
      <App setSDKReady={setReady}></App>
    </Suspense>
  </>)
}